import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalCompleteUserDataComponent } from '../modal-complete-user-data.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'src/app/core/auth/auth.service';
import { CiudUserAuthData, LoginDataService } from 'src/app/core/auth/authData.model';
import { env, python } from 'src/environments/environments';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private readonly apiWeb2 = `${python.url_base}`;

  private ciudUserSubject = new BehaviorSubject<CiudUserAuthData | null>(null);
  public ciudUser$ = this.ciudUserSubject.asObservable();

  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    private loginDataService: LoginDataService,
    private authService: AuthService
  ) {}

  openDialog(): void {
    this.dialog.open(ModalCompleteUserDataComponent, {
      width: '400px',
    });
  }


  updateMyProfile(ciudadano: CiudUserAuthData): Observable<{ success: number; message: string; data?: any }> {
    const urlResource: string = `${this.apiWeb2}/actualizarMiPerfil`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.authService.performProtectedRequest(() =>
        this.http.put<{ success: number; message: string; data?: any }>(
          urlResource,
          ciudadano,
          {
            headers,
            withCredentials: true,
          }
        )
      )
    .pipe(

      map(response => {
        if (response.success) {
          this.authService.updateUserProfile(response.data);
          const userData = new CiudUserAuthData(response.data );
          this.loginDataService.setData(new CiudUserAuthData(response.data));
          this.ciudUserSubject.next(userData);
          sessionStorage.setItem('user', JSON.stringify(userData));


          return { success: 1, message: 'Ciudadano actualizado', data: userData };
        } else {

          console.error('Error al actualizar el ciudadano:', response);
          return { success: 0, message: 'Error al actualizar el ciudadano', data: response.data };
        }
      }),
      catchError(error => {
        console.error('API error:', error);
        return of({ success: 0, message: error.message, data: [] });
      })
    );
  }
}

